"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PendingCircleIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

var _excluded = ["title"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** PendingCircleIcon */
var PendingCircleIcon = function PendingCircleIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Pending" : _ref$title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 18 18"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Title, null, title), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    d: "M7 14.5C10.866 14.5 14 11.366 14 7.5C14 3.63401 10.866 0.5 7 0.5C3.13401 0.5 0 3.63401 0 7.5C0 11.366 3.13401 14.5 7 14.5ZM6.75 4.5C6.75 4.08579 6.41421 3.75 6 3.75C5.58579 3.75 5.25 4.08579 5.25 4.5V8.25C5.25 8.55278 5.43205 8.82586 5.71154 8.94231L8.71154 10.1923C9.09389 10.3516 9.533 10.1708 9.69231 9.78846C9.85162 9.40611 9.67081 8.967 9.28846 8.80769L6.75 7.75V4.5Z",
    fill: (0, _helpers.color)(props.fill),
    fillRule: "evenodd"
  }));
};

exports.PendingCircleIcon = PendingCircleIcon;
PendingCircleIcon.displayName = "PendingCircleIcon";
//# sourceMappingURL=PendingCircleIcon.js.map